var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-avatar px",class:{ mobile: _vm.isMobile, small: _vm.small }},[_c('img',{attrs:{"src":_vm.src || _vm.images.avatar,"alt":"Avatar"},on:{"click":function($event){return _vm.$emit('click')},"error":({ target }) => {
        target.src = _vm.images.avatar;
      }}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }